import React from "react";

import css from "./RoomSchemeSize.module.css";

import cn from "classnames";
import { round } from "lodash";

type Props = {
    value: number;
    isRotated: boolean;
    isVisible: boolean;
};

export const RoomSchemeSize: React.FC<Props> = ({ value, isRotated, isVisible }) => {
    return (
        <div className={cn(css.main, isRotated && css.rotated, !isVisible && css.hidden)}>
            {round(value, 3)} мм
        </div>
    );
};
